export type BitbucketApiClientOptions = {
  token: string | null | undefined;
  expiration: number | null | undefined;
};

function anonymousToken() {
  const tokenDetails: BitbucketApiClientOptions = {
    token: null,
    expiration: null,
  };

  return tokenDetails;
}

export function parseTokenDetailsFromMetaTag(): BitbucketApiClientOptions {
  const tokenMetaTag = document.querySelector('meta[name=apitoken]');

  const rawTokenDetails =
    tokenMetaTag && tokenMetaTag.hasAttribute('content')
      ? tokenMetaTag.getAttribute('content')
      : null;

  if (rawTokenDetails) {
    try {
      const tokenDetails = JSON.parse(rawTokenDetails);

      // convert tokenDetails expiration to milliseconds
      if (tokenDetails.expiration) {
        tokenDetails.expiration *= 1000;
      }

      return tokenDetails;
    } catch {
      return anonymousToken();
    }
  }

  return anonymousToken();
}

// @ts-ignore TODO: fix noImplicitAny error here
export const getAuthHeader = options => {
  // Anonymous user have no token
  if (!options.token) {
    return {};
  }

  return {
    Authorization: `Bearer ${options.token ? options.token : ''}`,
  };
};
